<template>
  <div >
    <div class="text-lg-h4 text-h6">{{liveSource.name}}</div>
    <v-layout class="grey darken-2" justify-center :fill-height="true">
      <v-flex lg6>
        <div class="facebook-responsive">
          <div
            class="fb-video"
            :data-href="liveSource.streaming_url"
            data-autoplay="true"
            data-width="1000"
            data-show-text="false"
            data-lazy="true"
            data-allowfullscreen="false"
          ></div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: 'LivePanel',
  props:{
    liveSource:{
      type:Object
    }
  }
}
</script>

<style>
</style>